var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompletedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H10C4.47715 0 0 4.47715 0 10V50C0 55.5228 4.47715 60 10 60H50C55.5228 60 60 55.5228 60 50V10C60 4.47715 55.5228 0 50 0Z",
    fill: "#A8D060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3742 36.4921L44.7482 16.1171C45.0313 15.8338 45.3675 15.6091 45.7375 15.4557C46.1076 15.3024 46.5042 15.2235 46.9047 15.2235C47.3052 15.2235 47.7018 15.3024 48.0718 15.4557C48.4419 15.6091 48.7781 15.8338 49.0612 16.1171L49.1062 16.1601C49.6778 16.7322 49.9989 17.5078 49.9989 18.3166C49.9989 19.1253 49.6778 19.901 49.1062 20.4731L25.7062 43.8731C25.1264 44.4521 24.3406 44.7773 23.5212 44.7773C22.7018 44.7773 21.9159 44.4521 21.3362 43.8731L10.8942 33.4231C10.3226 32.851 10.0015 32.0753 10.0015 31.2666C10.0015 30.4578 10.3226 29.6822 10.8942 29.1101L10.9382 29.0671C11.2212 28.7837 11.5573 28.5589 11.9272 28.4055C12.2972 28.2521 12.6937 28.1732 13.0942 28.1732C13.4947 28.1732 13.8912 28.2521 14.2612 28.4055C14.6311 28.5589 14.9672 28.7837 15.2502 29.0671L22.6722 36.4891C22.7837 36.6009 22.9162 36.6897 23.062 36.7503C23.2079 36.8108 23.3643 36.842 23.5222 36.842C23.6801 36.842 23.8365 36.8108 23.9824 36.7503C24.1282 36.6897 24.2607 36.6009 24.3722 36.4891",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedIcon);
export default __webpack_public_path__ + "static/media/completed-icon.89c5bbe8.svg";
export { ForwardRef as ReactComponent };